import { Divider, Stack, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router';

import HaufeAkademieLogo from '../../public/assets/images/haufe-akademie-logo.svg';
import HaufeGroupLogo from '../../public/assets/images/haufe-group-logo.svg';
import { url } from '../url';

export const Footer = () => {
  const theme = useTheme();

  return (
    <Stack sx={{ backgroundColor: theme.palette.surface.brandDark, px: 6 }}>
      <Stack alignItems="center" direction="row" sx={{ py: 3, justifyContent: 'space-between' }}>
        <img alt="Haufe Akademie Logo" src={HaufeAkademieLogo} style={{ height: 24 }} />
        <Stack>
          <Typography variant="labelLight" color="textTertiaryOnBrand" sx={{ mb: 1 }}>
            Eine Marke der
          </Typography>
          <img alt="Haufe Akademie Logo" src={HaufeGroupLogo} style={{ height: 29 }} />
        </Stack>
      </Stack>
      <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.27)' }} />
      <Stack direction="row" sx={{ py: 3, justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to={url.datenschutz()} style={{ textDecoration: 'none' }}>
          <Typography component="span" variant="label" color="textBrandLight">
            Datenschutz
          </Typography>
        </Link>
        <Typography variant="labelLight" color="textSecondaryOnBrand">
          Powered by Team VAMOS
        </Typography>
      </Stack>
    </Stack>
  );
};
